// extracted by mini-css-extract-plugin
module.exports = {"footer":"ExpressPlanFooter_footer__qv4aS","footerText":"ExpressPlanFooter_footerText__2bzky"};